import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AddEditUserPackage from "../../../components/AddEditUserPackage";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { setProductId, setProductPageType } from "../../../lib/slices/detailIdsSlice";
import AllProductsReviews from "./AllReviews";
import BasePackagesList from "./BasePackagesList";
import ProductList from "./ProductList";


import AddEditPackage from "../../../components/AddEditPackage";
import CustomPackageList from "./CustomPackageList";
import AddEditProduct from "../../../components/AddEditProduct/AddEditProduct";
import { UserPlan } from "./userPlan";
import RestockProduct from "./restock";
import { Inventory } from "./inventory";

const tabs = [
  { label: "products", value: "product_list" },
  { label: "basePackages", value: "base_packages_list" },
  { label: "customPackages", value: "custom_packages_list" },
  { label: "usersPlans", value: "user_plans" },
  { label: "reviews", value: "all_reviews" },
  // { label: "restockProduct", value: "restock_product" },
  { label: "inventoryMovements", value: "inventory_movements" },
];

function Products() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, productList: tab }));

    if (tab === "add_edit_product") {
      dispatch(setProductPageType("add"));
      dispatch(setProductId(""));
    }
  };

  const renderTabs = (activeTab) => {
    switch (activeTab) {
      case "product_list":
        return <ProductList handleChangeTab={handleChangeTab} />;
      case "add_edit_product":
        return <AddEditProduct handleChangeTab={handleChangeTab} />;
      case "base_packages_list":
        return <BasePackagesList handleChangeTab={handleChangeTab} />;
      case "custom_packages_list":
        return <CustomPackageList handleChangeTab={handleChangeTab} />;
      case "all_reviews":
        return <AllProductsReviews handleChangeTab={handleChangeTab} />;
      case "add_edit_package":
        return <AddEditPackage handleChangeTab={handleChangeTab} />;
      case "user_package_details":
        return <AddEditUserPackage handleChangeTab={handleChangeTab} />;
      case "user_plans":
        return <UserPlan handleChangeTab={handleChangeTab} />;
      case "restock_product":
        return <RestockProduct handleChangeTab={handleChangeTab} />;
      case "inventory_movements":
        return <Inventory handleChangeTab={handleChangeTab} />;
      default:
        return null;
    }
  }

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"products"}
            tabs={tabs}
            activeTab={activeTab.productList}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {renderTabs(activeTab.productList)}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default Products;
